import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { getData, postData } from "../../../utils/api";

const CourierViewModal = ({
  show,
  handleClose,
  selectedOrder,
  setShowSuccessModal,
  setSuccessText,
  title = "Select Courier Service",
  listEndpoint = "/admin/orders/couriers",
  selectEndpoint = "/admin/orders/select-courier",
}) => {
  const [couriers, setCouriers] = useState([]);
  const [selectedCourier, setSelectedCourier] = useState(null);
  const [shipmentId, setShipmentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!show || !selectedOrder?.id) return;

    const fetchCouriers = async () => {
      setSelectedCourier(null);
      setShipmentId(null);
      setCouriers([]);
      setErrorMessage("");
      setLoading(true);

      const response = await getData(`${listEndpoint}/${selectedOrder.id}`);

      if (response?.success === false) {
        setErrorMessage(
          response?.errors || response?.message || "Failed To Fetch Couriers",
        );
      } else {
        setCouriers(response?.data?.couriers || []);
        setShipmentId(response?.data?.shipment_id || null);
      }
      setLoading(false);
    };

    fetchCouriers();
  }, [show, selectedOrder?.id, listEndpoint]);

  const handleConfirm = async () => {
    if (!selectedCourier) return;

    setSubmitting(true);
    setErrorMessage("");

    try {
      const response = await postData(
        `${selectEndpoint}/${selectedOrder.id}`,
        {
          shipment_id: shipmentId,
          courier_company_id: selectedCourier,
        },
      );

      if (!response?.success) {
        setErrorMessage(
          response?.errors || response?.message || "Failed To Assign Courier",
        );
        return;
      }

      handleClose(true);
      setSuccessText("Courier Assigned Successfully");
      setShowSuccessModal(true);
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.errors ||
          error?.response?.data?.message ||
          "Failed To Assign Courier",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => handleClose(false)}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorMessage && (
          <div className="alert alert-danger">
            {typeof errorMessage === "string"
              ? errorMessage
              : JSON.stringify(errorMessage)}
          </div>
        )}
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Select</th>
              <th>Courier</th>
              <th>Rate</th>
              <th>Estimated Delivery</th>
              <th>COD</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="text-center">
                  <Spinner animation="border" size="sm" />
                </td>
              </tr>
            ) : couriers.length > 0 ? (
              couriers.map((courier) => (
                <tr key={courier?.courier_company_id}>
                  <td>
                    <input
                      type="radio"
                      name="courier"
                      checked={selectedCourier === courier?.courier_company_id}
                      onChange={() =>
                        setSelectedCourier(courier?.courier_company_id)
                      }
                    />
                  </td>
                  <td>{courier?.courier_name}</td>
                  <td>₹ {courier?.freight_charge}</td>
                  <td>{courier?.etd}</td>
                  <td>{Number(courier?.cod) === 1 ? "Yes" : "No"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center">
                  No couriers found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleClose(false)}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={!selectedCourier || submitting}
          onClick={handleConfirm}
        >
          {submitting ? "Assigning..." : "Confirm Courier"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CourierViewModal;
